import useAxios from '../../../library/axios'; 

//import IGroupPolicy from '../model/GroupPolicy';

const _ = () => {

    const axios = useAxios();    

    const getEnumerationsList = async ()  => {
        const {data} = (await axios.get('/configuration/enumeration/getEnumerationsList'));
        return await data;
      }

    const getEnumerationItemsList = async (enumerationCode: string)  => {
        const {data} = (await axios.get(`/configuration/enumeration/getEnumerationItemsList/${enumerationCode}`));
        return await data;
      }

    const getEnumerationItemsListBatch = async (enumerationCodes: string[])  => {
      const codes = enumerationCodes.join('wxyz');
      const {data} = (await axios.get(`/configuration/enumeration/getEnumerationItemsListBatch/${codes}`));
      
      return await data;
    }
    
    const getLanguagesList = async ()  => {
        const {data} = (await axios.get(`/configuration/enumeration/getLanguagesList/`));
        return await data;
      }

      const getEnumerationItemsLanguageList = async ()  => {
        const {data} = (await axios.get(`/configuration/enumeration/getEnumerationItemsLanguageList/`));
        return await data;
      }  

      
    return {        

        getEnumerationsList,      
        getEnumerationItemsList,
        getEnumerationItemsListBatch,
        getEnumerationItemsLanguageList,
        
        getLanguagesList,
      
    } 
}

export default _;